import React from 'react';
import { motion } from 'framer-motion';
export function GuaranteeSection() {
  return <section className="bg-[#FEF7E8]" data-id="element-94">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="flex flex-col md:flex-row items-stretch" data-id="element-95">
        {/* Left: Guarantee content */}
        <div className="flex-1 flex flex-col justify-center px-8 py-6 md:px-12" data-id="element-96">
          <div className="flex flex-col sm:flex-row items-center gap-4 mb-4" data-id="element-97">
            <img src="https://cdn.magicpatterns.com/uploads/r8nSn2xyyAgjWmwb7YDRb6/pngtree-100-satisfaction-guaranteed-gold-badge-seal-png-image_20957525.png" alt="Sello 100% Garantizado" className="w-16 h-16 object-contain flex-shrink-0" data-id="element-98" />
            <div className="text-center sm:text-left" data-id="element-99">
              <h3 className="text-lg md:text-xl font-extrabold text-gray-900 leading-snug" data-id="element-100">
                GARANTÍA DE <span className="text-red-700" data-id="element-101">60 DÍAS</span>:{' '}
                <span className="italic" data-id="element-102">"BIENESTAR TOTAL"</span>
              </h3>
              <p className="text-gray-700 mt-1 text-sm leading-relaxed" data-id="element-103">
                Si en 60 días no ves mejorías, te{' '}
                <strong data-id="element-104">devolvemos el 100% del dinero</strong>. Sin preguntas.
              </p>
            </div>
          </div>

          <div className="border-t border-orange-200 mb-3" data-id="element-105" />

          <p className="text-green-700 font-bold text-xs text-center mb-2" data-id="element-106">
            🌿 Comprá con total tranquilidad: Tenés nuestra Garantía Bienestar
            Total de 60 Días.
          </p>
          <p className="text-gray-700 text-xs leading-relaxed text-center" data-id="element-107">
            Probá todas las recetas durante 60 días completos. Prepararlas,
            disfrutarlas con tu familia y comprobá los resultados en la salud y
            energía de tus hijos. Si después de 2 meses no ves mejoras claras
            —como más concentración, mejor rendimiento en el colegio, más
            energía en el día a día o simplemente no te encanta el recetario—{' '}
            <strong data-id="element-108">te devolvemos el 100% de tu dinero</strong>. Sin preguntas,
            sin excusas, sin letra chica. El riesgo es 100% nuestro. La
            transformación en la salud de tu hijo puede ser 100% tuya.
          </p>
        </div>

        {/* Right: Mercado Pago image */}
        <div className="flex-1 flex items-stretch justify-center bg-white overflow-hidden" data-id="element-109">
          <img src="https://cdn.magicpatterns.com/uploads/exnF17cDNEq91LXz1fKfr9/Imagen_21-2-26_a_las_4.23_p._m._(1).jpg" alt="Mercado Pago - medios de pago aceptados" className="w-full object-cover object-center" data-id="element-110" />
        </div>
      </motion.div>
    </section>;
}